import React from 'react';
import './Home.css';
import { Link, useNavigate } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate()
  const handleClick = (PageLink) => {
    navigate(`/products/${PageLink}`); // <- dynamic route
  };
  
  const productCategory = [
    {
      title: "Alloy Metal Scrap",
      description: "High-grade scrap from alloyed metals for industrial reuse.",
      image: "/Products/AlloyMetalScrap.jpg",
      PageLink: "alloy-metal-scrap"
    },
    {
      title: "Non-Alloy Metal Scrap",
      description: "Raw, non-alloyed scrap ideal for basic metal processing.",
      image: "/Products/Non-AlloyMetalScrap.jpg",
      PageLink: "non-alloy-metal-scrap"
    },
    {
      title: "Ferrous Metal",
      description: "Iron-based scrap materials sourced from heavy machinery.",
      image: "/Products/img3.jpg",
      PageLink: "ferrous-metal"
    },
    {
      title: "Non-Ferrous Metal",
      description: "Copper, aluminum, and other non-iron scrap metals.",
      image: "/Products/Non-FerrousMetal.avif",
      PageLink: "non-ferrous-metal"
    },
    {
      title: "Specialty & Mixed Scrap",
      description: "Blended scrap materials including rare and specialty metals.",
      image: "/Products/mixed.avif",
      PageLink: "specialty-mixed-scrap"
    },
    {
      title: "Agro Products",
      description: "Naturally harvested goods ready for export and trade.",
      image: "/Products/agro.avif",
      PageLink: "agro-products-export"
    },
    {
      title: "Agriculture Commodities",
      description: "Staple grains, oilseeds, and other high-demand agricultural goods for domestic and international markets.",
      image: "/Products/Agriculture.jpeg",
      PageLink: "agriculture-commodities"
    },
    {
      title: "Medical Equipment",
      description: "Reliable, industry-standard medical equipment and tools.",
      image: "/Products/medical.avif",
      PageLink: "medical-equipment"
    }
  ];
  return (
    <div className="mainHome-container">
       <section className="hero-section">
      <div className="hero-content">
        <h1>Global Metal Scrap &<br />Commodity Trading Excellence</h1>
        <p>
          Your trusted partner for domestic and international trading of metal scraps,
          agricultural products, and medical equipment.
        </p>
        <div className="hero-buttons">
          <Link to="/products/catagories" style={{color:"white"}}><button className="explore-btn">Explore Products</button> </Link>
          <Link to="/contact" style={{color:"black"}}><button className="contact-btn">Contact Us</button></Link>
        </div>
      </div>
    </section>
      <section className="why-choose">
      <div className="why-choose-header">
        <h2>Why Choose PKRVeda Global?</h2>
        <p>
          We provide comprehensive trading solutions for metal scrap, agricultural products, and more with a focus on quality and reliability.
        </p>
      </div>

      <div className="why-choose-grid">
        {features.map((feature, index) => (
          <div key={index} className="why-box">
            <div className="icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
    <section className="product-categories-1">
      <h2>Our Product Categories</h2>
      <p>Explore our diverse range of products across multiple industries</p>
      <section className="product-categories-list">
          <div className="product-categories-list-grid">
            {productCategory.slice(0,3).map((productCategory, index) => (
              <div
                key={index}
                className="product-categories-list-box"
                onClick={() => handleClick(productCategory.PageLink)} // <- add onClick
                style={{ cursor: 'pointer' }}
              >
                <div className="icon">
                  <img
                    src={productCategory.image}
                    alt={productCategory.image}
                    className="product-section-img"
                  />
                </div>
                <h3>{productCategory.title}</h3>
                <p>{productCategory.description}</p>
              </div>
            ))}
          </div>
        </section>
      <div className="product-catagory-buttons" style={{display:"flex",gap:"30px"}}>
      <Link to="/products/catagories" style={{color:"white"}}><button className="view-button" style={{marginBottom:"40px"}}>View all Products</button></Link>
      
      </div>
      
    </section>
    <section className="trading-process">
      <h2>Our Trading Process</h2>
      <p>Learn how we ensure smooth and efficient trading operations from inquiry to delivery</p>
      <div className="process-steps">
        {steps.map((step, index) => (
          <div key={index} className="step">
            <div className="step-number">{step.number}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
      <button className="start-button">Start Your Trading Journey</button>
    </section>
    </div>
  );
};

export default Footer;


const steps = [
    {
      number: '1',
      title: 'Inquiry & Consultation',
      description:
        'Initial discussion about your requirements, specifications, and volumes.',
    },
    {
      number: '2',
      title: 'Quotation & Agreement',
      description:
        'Transparent pricing, terms, and conditions based on your needs.',
    },
    {
      number: '3',
      title: 'Processing & Quality Check',
      description:
        'Sourcing, processing, and rigorous quality assurance procedures.',
    },
    {
      number: '4',
      title: 'Logistics & Delivery',
      description:
        'Efficient shipment coordination and on-time delivery to your location.',
    },
  ];
const features = [
    {
      icon: '🔩',
      title: 'Premium Quality Materials',
      description:
        'We source and trade only the highest quality materials that meet international standards and specifications.',
    },
    {
      icon: '🌐',
      title: 'Global Network',
      description:
        'Our extensive network spans across continents, enabling efficient domestic and international trading operations.',
    },
    {
      icon: '🤝',
      title: 'Trusted Partnerships',
      description:
        'We build long-term relationships with suppliers and clients based on mutual trust and transparent business practices.',
    },
    {
      icon: '🚚',
      title: 'Efficient Logistics',
      description:
        'Our optimized logistics systems ensure timely delivery of all products, regardless of volume or destination.',
    },
    {
      icon: '♻️',
      title: 'Sustainable Practices',
      description:
        'We’re committed to environmental responsibility through sustainable metal recycling and trading practices.',
    },
    {
      icon: '🎖️',
      title: 'Certified Operations',
      description:
        'Our business complies with international quality standards and certifications for all product categories.',
    },
  ];